import { FormField } from '../form.field';
import { IFormField } from '../form.interface';

export class SelectField<T = string> extends FormField<T> {
  constructor(args?: IFormField<T>) {
    super({
      ...args,
      ...{
        inputMethod: 'selecting'
      }
    });
  }
}
